import "../styles/ToggleButton.css";

const ToggleButton = ({ sidebarOpen, onToggle, style }) => {
  return (
    <button className="toggle-button" 
    onClick={onToggle}
    style={style}
    >
      {sidebarOpen ? "←" : "☰"} 
    </button>
  );
};

export default ToggleButton;
